const FAVORITES_STORAGE_KEY = 'kabyleGame_favoriteWords';

export function getFavoriteWords(): string[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(FAVORITES_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    console.error('Error loading favorite words:', e);
    return [];
  }
}

export function isFavoriteWord(kab: string): boolean {
  if (!kab) return false;
  const list = getFavoriteWords();
  return list.includes(kab);
}

export function toggleFavoriteWord(kab: string): boolean {
  if (typeof window === 'undefined' || !kab) return false;
  try {
    const list = getFavoriteWords();
    const index = list.indexOf(kab);
    let isNowFavorite = false;
    let newList: string[];

    if (index >= 0) {
      newList = list.filter((item) => item !== kab);
      isNowFavorite = false;
    } else {
      newList = [...list, kab];
      isNowFavorite = true;
    }

    localStorage.setItem(FAVORITES_STORAGE_KEY, JSON.stringify(newList));
    window.dispatchEvent(new CustomEvent('kabyle_favorites_updated', { detail: { favorites: newList, changed: kab, isFavorite: isNowFavorite } }));
    return isNowFavorite;
  } catch (e) {
    console.error('Error saving favorite words:', e);
    return false;
  }
}

export function setFavoriteWords(favorites: string[]): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(FAVORITES_STORAGE_KEY, JSON.stringify(favorites));
    window.dispatchEvent(new CustomEvent('kabyle_favorites_updated', { detail: { favorites } }));
  } catch (e) {
    console.error('Error setting favorite words:', e);
  }
}
